import React, { useEffect, useState } from 'react';
import Button from '../../components/shared/custom-btn';
import { RxCross2 } from 'react-icons/rx';
import DateTimeLocalInput from '../../components/shared/datetime-input';
import CustomTextarea from '../../components/shared/custom-textarea';
import CustomReactSelect from '../../components/shared/custom-react-selector';
import ModalHeading from '../../components/shared/modal-heading';
import { createIncidents } from '../../services/incidents-service';
import GoogleMapComponent from '../../components/shared/google-map';
import Loader from '../../components/shared/loader';

const AddModal = ({ handleCloseAddModal, fetchMainGlobalData, globalDataloading, onAdd, openEditModal, vehicle, typesOptions, drivers, vehicles, isVehicleEditable = true, accountId, fetchIncidents }) => {
  const [formData, setFormData] = useState({
    incidentTime: '',
    vehicleId: vehicle ? vehicle.vehicleId : '',
    causedBy: '',
    type: '',
    note: '',
    location: '51.505,-0.09',
  });

  const [showMap, setShowMap] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const vehicleOptions = [
    // { value: '', label: 'Select Vehicle' },
    ...(vehicles?.map(vehicle => ({ value: vehicle.vehicleId, label: vehicle.label })) || []),
  ];

  const typesOption = [
    // { value: '', label: 'Select Type' },
    ...(typesOptions?.map(type => ({ value: type.slug, label: type.label })) || []),
  ];

  const driverOptions = [
    // { value: '', label: 'Select Driver' },
    ...(drivers?.map(driver => ({ value: driver.userId, label: driver.label })) || []),
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, option) => {
    setFormData((prev) => ({ ...prev, [name]: option ? option.value : '' }));
  };

  const handleLocationChange = (location) => {
    setFormData((prev) => ({ ...prev, location }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading || successMessage) return;
    setIsLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      const utcTime = formData.incidentTime ? new Date(formData.incidentTime).toISOString() : '';
      const payload = {
        vehicleId: formData.vehicleId,
        incidentTime: utcTime,
        type: formData.type,
        causedBy: formData.causedBy,
        location: formData.location,
        note: formData.note,
      };

      console.log(payload)
      const response = await createIncidents(payload, accountId);
      if (response.success) {
        const newItem = response.data.data;
        onAdd?.(newItem);
        fetchIncidents?.('Incidents');
        openEditModal?.(newItem);
        setSuccessMessage('Incident added successfully!');
        setTimeout(() => {
          handleCloseAddModal();
        }, 1000);
      } else {
        setErrorMessage(response.data.message || 'Failed to add incident');
      }
    } catch (error) {
      console.error('Error adding incident:', error);
      setErrorMessage('An error occurred while adding the incident');
    } finally {
      setIsLoading(false);
    }
  };

  const initialLocation = formData.location.split(',').map(Number);
  const mapPosition = { lat: initialLocation[0], lng: initialLocation[1] };

  useEffect(() => {
    if (typeof fetchMainGlobalData === 'function') {
      fetchMainGlobalData();
    }
  }, [])

  return (
    <form onSubmit={handleSubmit} className="space-y-2 pt-3 relative">
      <ModalHeading className="text-left mb-3 border-b border-gray-300 px-4 pb-2">
        Add Incident Detail
      </ModalHeading>

      <button
        className="hover:scale-105 absolute -top-2 right-2 bg-white border p-2 rounded-full"
        onClick={handleCloseAddModal}
      >
        <RxCross2 className="text-xl" />
      </button>

      {successMessage && (
        <div className="mb-4 px-4 py-2 bg-green-100 text-green-800 rounded-md text-sm text-center">
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div className="mb-4 px-4 py-2 bg-red-100 text-red-800 rounded-md text-sm text-center">
          {errorMessage}
        </div>
      )}

      {globalDataloading ? (
        <Loader />
      ) : (!vehicles || vehicles.length === 0) ? (
        <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
          <p className="text-gray-600 text-lg mb-2">There are no vehicles in your account.</p>
          <p className="text-gray-500">Please create a vehicle to start using this feature.</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 px-4 gap-y-2 gap-x-2">
            <DateTimeLocalInput
              label="Time"
              name="incidentTime"
              value={formData.incidentTime}
              onChange={handleChange}
              inputStyle="!py-[7px]"
              labelGap="!gap-0.5"
              labelStyle="text-gray-700"
              required={true}
              allowFutureDates={false}
            />

            <CustomReactSelect
              label="Type"
              name="type"
              value={typesOption.find((option) => option.value === formData.type) || null}
              onChange={(option) => handleSelectChange('type', option)}
              options={typesOption}
              placeholder='Select type'
              required={true}
            />

            <CustomReactSelect
              label="Vehicle"
              name="vehicleId"
              value={vehicleOptions.find((option) => option.value === formData.vehicleId) || null}
              onChange={(option) => handleSelectChange('vehicleId', option)}
              options={vehicleOptions}
              required={true}
              isEditable={isVehicleEditable}
              placeholder='Select vehicle'
            />

            <CustomReactSelect
              label="Caused By"
              name="causedBy"
              value={driverOptions.find((option) => option.value === formData.causedBy) || null}
              onChange={(option) => handleSelectChange('causedBy', option)}
              options={driverOptions}
              placeholder='Select driver'
              required={true}
            />

            <div className={`flex flex-col sm:col-span-2 ${showMap ? 'mb-20' : 'mb-0'} gap-1.5 w-full`}>
              <button
                type="button"
                className={` bg-gray-200 px-2 text-sm py-1.5 rounded-lg mt-2`}
                onClick={() => setShowMap(!showMap)}
              >
                {showMap ? 'Hide Map' : 'Select Location on Map'}
              </button>
              <GoogleMapComponent
                isVisible={showMap}
                initialLocation={mapPosition}
                onLocationChange={handleLocationChange}
              />
            </div>

            <div className="w-full sm:col-span-2">
              <CustomTextarea
                label="Note"
                name="note"
                value={formData.note}
                onChange={handleChange}
                placeholder=""
                labelGap="!gap-0.5"
                labelStyle="text-gray-700"
                rows={2}
                maxLength={500}
              />
            </div>
          </div>

          <div className="flex justify-end px-4">
            <Button
              label="Save"
              type="submit"
              loading={isLoading}
              loadingLabel="Saving..."
              className="bg-btnBg rounded-lg !py-1 text-white"
              disabled={isLoading || !!successMessage}
            />
          </div>
        </>
      )}

    </form>
  );
};

export default AddModal;